export default __webpack_public_path__ + "static/media/imagecutout_addbackgroundcolor.33cfb623.jpg";